module.exports = {
	"articleTitle1": "Best of Ann Arbor 2017: Full List ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Marnee Thai",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/arts/best-ann-arbor-2012-list",
	"articleSnippet1": "Apr 12, 2017 ... Italian Food: Gratzi. Korean Food: Bell's Diner & Seoul Garden (Tie). Thai Food: \nMarnee Thai. Mediterranean Food: Ahmo's Gyros & Deli.",
	"articleSnippet2": "Apr 11, 2012 ... Best Thai Food Winner: No Thai Runner-up: Marnee Thai. Best New Business \nWinner: Bongz and Thongz Runner-up: Vintage Twin.",
	"foodRecommendations": [],
	"articleTitle2": "Best of Ann Arbor 2012 List",
	"address": "414 S Main St #130, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.277198,
		"lng": -83.749123
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/marneethai.json
// module id = 913
// module chunks = 0